import React from 'react';
import cn from 'clsx';
import { ArticleHeading2, ArticleParagraph2, Image, useDeviceType } from '@cian/ui-kit';
import { TRealEstateType, TObjectType } from 'shared/types/common/offer';
import { IBankInfo } from 'shared/types/common/bank';
import { IRow } from '../../../../repositories/mortgage-broker-calculator/entities/modal/Row';

import styles from './styles.css';

export interface ITitleProps extends IBankInfo {
  objectType: TObjectType;
  realEstateType: TRealEstateType;
  modalContent?: IRow[];
}

const mapObjectType: Record<TObjectType, string> = {
  house: 'Дом',
  apartments: 'Апартаменты',
  flat: 'Квартира',
  carPlace: 'Машиноместо',
};

const mapRealEstateType: Record<TRealEstateType, string> = {
  newBuilding: 'Новостройка',
  secondary: 'Вторичка',
  houseBuilding: 'Строительство дома',
};

export const Title: React.FC<ITitleProps> = ({ iconPath, objectType, realEstateType, name }) => {
  const deviceType = useDeviceType();
  const tags = [mapObjectType[objectType], mapRealEstateType[realEstateType]];

  return (
    <header className={cn(styles['wrapper'], styles[deviceType])}>
      <div className={cn(styles['img-wrapper'], styles[deviceType])}>
        <Image
          src={'https://static.cdn-cian.ru/frontend/mortgage-assets/banks/' + iconPath}
          title={name}
          alt={name}
          preloader
        />
      </div>
      <div>
        <ArticleHeading2>{name}</ArticleHeading2>
        <ul className={styles['list']}>
          {tags.map((el, index) => {
            return (
              <li key={index} className={styles['list-item']}>
                <ArticleParagraph2>{el}</ArticleParagraph2>
              </li>
            );
          })}
        </ul>
      </div>
    </header>
  );
};
